import {
  EuiLink,
  EuiEmptyPrompt,
  EuiTitle,
  EuiText,
} from "@inscopix/ideas-eui";
import { useRouteMapContext } from "providers/RouteMapProvider/RouteMapProvider";
import { useTenantContext } from "providers/TenantProvider/TenantProvider";
import { useToolDataContext } from "pages/tool/ToolDataProvider";

/*
 * Tool page panel to prompt the user to continue editing an in-progress first draft
 */
export const ToolPanelContinueFirstDraft = () => {
  const { tool } = useToolDataContext();
  const routeMap = useRouteMapContext((s) => s.routeMap);
  const currentTenant = useTenantContext((s) => s.currentTenant);

  return (
    <EuiEmptyPrompt
      hasBorder={true}
      layout="vertical"
      style={{ maxInlineSize: "unset", width: "100%" }}
      body={
        <EuiText>
          <p>No published tool versions.</p>
          <p>
            Continue editing your{" "}
            <EuiLink
              onClick={() =>
                routeMap.TOOL_EDITOR.dynamicPath({
                  tenantKey: currentTenant.key,
                  toolId: tool.id,
                  toolVersionId: tool.tool_versions[0].id,
                }).navigateTo()
              }
            >
              first draft
            </EuiLink>
          </p>
        </EuiText>
      }
      footer={
        <>
          <EuiTitle size="xxs">
            <h3>Want to learn more?</h3>
          </EuiTitle>
          <EuiLink
            href="https://inscopix.github.io/ideas-docs/custom_tools/index.html"
            target="_blank"
          >
            Read the docs
          </EuiLink>
        </>
      }
    />
  );
};
